module.exports = __webpack_public_path__ + "img/damage-scratch.2594100b.png";